module.exports = __webpack_public_path__ + "flyer_background_sunflower_010-e405ff56db238398bb359827bbeef7a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_sunflower_010.jpg
// module id = 1696
// module chunks = 1